import React, { useContext } from 'react';
import styled from 'styled-components';
import { Segment } from 'semantic-ui-react';
import { PatientContext } from 'components/patient/PatientContext';
import PatientInfo from 'components/patient/PatientInfo';
import PatientToolbar from 'components/patient/PatientToolbar';
import { MessageSourceProps, withMessages } from "react-message-source";
import { MandateConsumerRenderProps, MandateContext } from 'components/MandateContext';
import HomeLeftHeaderTitle from 'components/layout/HomeLeftHeaderTitle';
import HomeLeftHeader from 'components/layout/HomeLeftHeader';
import { PatientDto } from 'ts-types/api.types';

const StyledPatient = styled(Segment)`
  max-height: 210px;
  min-height: 190px;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

interface Props extends MessageSourceProps {
  isHome: boolean,
  changePatient?: (patient?: PatientDto) => void,
  onPatientRefresh?: (patient?: PatientDto) => void
}

const Patient = (props: Props) => {

  const {currentPatient, changePatient, onPatientRefresh, patientLoading} = useContext(PatientContext);
  const {currentMandates, getAllMandates}: MandateConsumerRenderProps = useContext(MandateContext);
  const styleProblematic = {borderBottom: "2px solid #ff1133"};

  const isPatientProblematic = currentPatient
      && (currentPatient.invoiceProblematic || currentPatient.doctorProblematic);

  return (
      <StyledPatient>
        <HomeLeftHeader style={isPatientProblematic ? styleProblematic : {}}>
          <HomeLeftHeaderTitle>{props.getMessage('patient')}</HomeLeftHeaderTitle>
          <PatientToolbar
              changePatient={props.changePatient ? props.changePatient : changePatient}
              currentPatient={currentPatient}
              currentMandates={currentMandates}
              getAllMandates={getAllMandates}
              onPatientRefresh={props.onPatientRefresh ? props.onPatientRefresh : onPatientRefresh}
              isHome={props.isHome}
          />
        </HomeLeftHeader>
        <PatientInfo
            currentPatient={currentPatient}
            patientLoading={patientLoading}
        />
      </StyledPatient>
  )
};

export default withMessages(Patient);
